/** Display formatting. Unknown values always render as an em dash, never as zero. */
const ngnFmt = new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 });
const usdFmt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const DASH = '—';

const num = (v: unknown): number | null => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export function naira(v: unknown): string {
  const n = num(v);
  return n === null ? DASH : `${n < 0 ? '−' : ''}₦${ngnFmt.format(Math.abs(Math.round(n)))}`;
}

/** Compact naira for headline figures: ₦9.74m, ₦850k. */
export function nairaShort(v: unknown): string {
  const n = num(v);
  if (n === null) return DASH;
  const a = Math.abs(n);
  const sign = n < 0 ? '−' : '';
  if (a >= 1_000_000) return `${sign}₦${(a / 1_000_000).toFixed(2)}m`;
  if (a >= 10_000) return `${sign}₦${Math.round(a / 1_000)}k`;
  return naira(n);
}

export function money(v: unknown, currency: string): string {
  const n = num(v);
  if (n === null) return DASH;
  if (currency === 'USD') return `${n < 0 ? '−' : ''}$${usdFmt.format(Math.abs(n))}`;
  if (currency === 'EUR') return `${n < 0 ? '−' : ''}€${usdFmt.format(Math.abs(n))}`;
  return naira(n);
}

export function monthLabel(monthStart: string): string {
  return new Date(`${monthStart}T00:00:00`).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
}

export function shortMonthLabel(monthStart: string): string {
  return new Date(`${monthStart}T00:00:00`).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}

export function dateLabel(value: string | null | undefined): string {
  if (!value) return DASH;
  const d = new Date(value.length === 10 ? `${value}T00:00:00` : value);
  return Number.isNaN(d.getTime()) ? DASH : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Signed change with direction words, e.g. "₦120k more" / "₦40k less". */
export function deltaLabel(current: unknown, previous: unknown): { text: string; direction: 'up' | 'down' | 'flat' } | null {
  const c = num(current);
  const p = num(previous);
  if (c === null || p === null) return null;
  const d = c - p;
  if (Math.abs(d) < 1) return { text: 'No change', direction: 'flat' };
  return { text: `${nairaShort(Math.abs(d))} ${d > 0 ? 'more' : 'less'}`, direction: d > 0 ? 'up' : 'down' };
}

export const toNumber = num;
